// ✅ EditItemModal.js
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Snackbar,
  Alert,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useOrder } from "../../../../../../../../context/OrderCreator/TablesContext/OrderContext"; // 👈 استدعاء الـ context

const EditItemModal = ({ open, onClose, item }) => {
  const { updateItem } = useOrder(); // 👈 نجيب الدالة من الكونتكست
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const theme = useTheme();
  // اجعل الـ Dialog fullScreen على الشاشات الصغيرة والتابلت الأصغر (توافق أفضل مع أجهزة التابلت/iPad)
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (item) setForm({ ...item });
  }, [item]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = async () => {
    console.log("🚀 handleSubmit اشتغل، item:", item, "form:", form); // ✅

    try {
      setLoading(true);

      console.log("📤 ارسال للتعديل:", {
        id: item?.id,
        quantity: form.quantity,
        price: form.price,
        note: form.note,
      });

      await updateItem({
        id: Number(item?.id),
        quantity: form.quantity,
        price: form.price,
        note: form.note,
      });

      setSuccess(true);
      onClose && onClose(true);
    } catch (err) {
      console.error("❌ خطأ في handleSubmit:", err);
      setError(err.message || "❌ فشل في تعديل بيانات الصنف");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        fullWidth
        maxWidth="md"
        fullScreen={fullScreen}
        PaperProps={{
          sx: {
            borderRadius: fullScreen ? 0 : 2,
            m: fullScreen ? 0 : 2,
          },
        }}
      >
        <DialogTitle>تعديل بيانات الصنف: {item?.product_name}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="الكمية"
                name="quantity"
                type="number"
                fullWidth
                value={form.quantity || ""}
                onChange={handleChange}
                variant="outlined"
                size="medium"
                inputProps={{
                  min: 1,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                sx={{
                  "& .MuiInputBase-input": { fontSize: { xs: 16, md: 18 }, padding: "12px" },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="السعر"
                name="price"
                type="number"
                fullWidth
                value={form.price || ""}
                onChange={handleChange}
                variant="outlined"
                size="medium"
                inputProps={{ inputMode: "decimal" }}
                sx={{
                  "& .MuiInputBase-input": { fontSize: { xs: 16, md: 18 }, padding: "12px" },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="ملاحظات"
                name="note"
                fullWidth
                value={form.note || ""}
                onChange={handleChange}
                multiline
                minRows={3}
                variant="outlined"
                sx={{
                  "& .MuiInputBase-input": { fontSize: { xs: 15, md: 17 }, padding: "12px" },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => onClose(false)}
            fullWidth={fullScreen}
            sx={{ mr: fullScreen ? 0 : 1 }}
          >
            إلغاء
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            size="large"
            fullWidth={fullScreen}
          >
            حفظ التعديلات
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!error}
        autoHideDuration={3000}
        onClose={() => setError("")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error">{error}</Alert>
      </Snackbar>

      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success">تم تعديل بيانات الصنف بنجاح</Alert>
      </Snackbar>
    </>
  );
};

export default EditItemModal;
